import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useNavigate } from 'react-router-dom';
import Confirmation from '../common/confimation.component';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
const CustomerImages = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [row, setCurrentRow] = useState(null);
const [previewUrl, setPreviewUrl] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    getImages();
  }, []);

  const getImages = () => {
    setLoading(true);
    DataService.getImages()
      .then((response) => {
        setImages(response.data.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleAddImage = () => {
    navigate('/add-image');
  };

  const deleteData = (row) => {
    setCurrentRow(row);
    setModalShow(true);
  };

  const updateStatus = () => {
    if (!row) return;

    setLoading(true);
    DataService.deleteImages({ id: row.id })
      .then((response) => {
        toast.success('Image Deleted Successfully.')
        getImages();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        console.log(error)
        toast.error(error.response.data.error)
        setLoading(false);
        setModalShow(false);
      });
  };

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      width: '280px',
    },
{
  name: 'Image',
  selector: row => row.url,
  sortable: false,
  cell: row => (
    <div onClick={() => setPreviewUrl(row.url)} style={{ cursor: 'pointer' }}>
      <img src={row.url} alt="Customer" style={{ width: 60, height: 60, objectFit: 'cover' }} />
    </div>
  ),
  width: '150px',
},
   {
  name: 'Actions',
  cell: row => (
    <div className="d-flex gap-2">
      <FontAwesomeIcon
        icon={faTrash}
        className="text-danger"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => deleteData(row)}
      />
    </div>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  width: '280px',
}
  ];
 

  return (
    <>
      <LoaderOverlay loading={loading} />
      {previewUrl && (
  <div
    className="preview-modal"
    onClick={() => setPreviewUrl(null)}
  >
    <img src={previewUrl} alt="Preview" />
  </div>
)}
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Customer Images</h4>
          <button className="btn btn-success" onClick={handleAddImage}>Add Image</button>
        </div>

        <DataTable
          columns={columns}
          data={images}
          pagination
          highlightOnHover
          striped
          responsive
          noHeader
        />
      </div>

      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={updateStatus}
        handleClose = {() => setModalShow(false)}

      />
    </>
  );
};

export default CustomerImages;
